import { render } from "./prontuarioRetorno.vue?vue&type=template&id=ca1356cc&scoped=true"
import script from "./prontuarioRetorno.vue?vue&type=script&lang=js"
export * from "./prontuarioRetorno.vue?vue&type=script&lang=js"

import "./prontuarioRetorno.vue?vue&type=style&index=0&id=ca1356cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca1356cc"]])

export default __exports__